<form
    [formGroup]="form"
    fxLayout="column"
    class="cipo--height--full p-t p-x-sm"
    data-testid="data-list-filters-panel"
    fxLayoutAlign="space-between stretch">
    <div fxLayout="column" class="cipo--overflow-y--auto">
        <div fxLayoutAlign="space-between center" class="p-x p-b">
            <mat-button-toggle-group
                [(value)]="filterLogic"
                class="btn-group"
                [hideSingleSelectionIndicator]="true"
                data-testid="data-list-filters-toggle-group">
                <mat-button-toggle [value]="0" data-testid="data-list-filters-toggle-and">
                    {{ "dataListCommand.filterByAll" | translate }}
                </mat-button-toggle>
                <mat-button-toggle [value]="1" data-testid="data-list-filters-toggle-or">
                    {{ "dataListCommand.filterByAny" | translate }}
                </mat-button-toggle>
            </mat-button-toggle-group>
            <button
                mat-raised-button
                class="toggle-all-btn"
                color="primary"
                data-testid="data-list-filters-expand-collapse"
                (click)="toggleAll()">
                {{ "dataListCommand." + (accordionClosed() ? "expandAll" : "collapseAll") | translate }}
                <mat-icon class="material-symbols-outlined" iconPositionEnd>
                    {{ accordionClosed() ? "expand_more" : "expand_less" }}
                </mat-icon>
            </button>
        </div>
        <mat-accordion displayMode="flat" multi class="cipo--border-sm cipo--border-radius--xs m-b-sm">
            @for (filter of filters(); track filter.fieldId) {
                @if (form.controls[filter.fieldId].value; as filterFormValue) {
                    <mat-expansion-panel
                        [formGroupName]="filter.fieldId"
                        [attr.data-testid]="'data-list-filters-filter data-list-filters-filter-' + filter.fieldId">
                        <mat-expansion-panel-header class="p-x-md">
                            <div fxLayout class="cipo--width--full" fxLayoutAlign="space-between center">
                                <p class="m-a-0 cipo--text--ellipsed">
                                    {{ filter.name | translate }}
                                    @if (![null, undefined, ""].includes(filterFormValue.value)) {
                                        <span class="cipo-text--accent-500">
                                            {{ "FILTER_OPERATORS." + filterFormValue.operator | translate }}
                                            <span class="cipo-text--warn-500">
                                                {{ filterFormValue.value | dataListFilterPipe: filter | translate }}
                                            </span>
                                        </span>
                                    }
                                </p>
                                @if (filterFormValue.value) {
                                    <button
                                        mat-icon-button
                                        (click)="$event.stopPropagation(); resetFilter(filter.fieldId)"
                                        [attr.aria-label]="'a11y.common.remove' | translate"
                                        color="warn">
                                        <mat-icon aria-hidden="true">close</mat-icon>
                                    </button>
                                }
                            </div>
                        </mat-expansion-panel-header>
                        <mat-form-field class="cipo-input m-l-sm filter-field">
                            <mat-select
                                formControlName="operator"
                                placeholder="Operator"
                                data-testid="data-list-filters-operator-select"
                                (selectionChange)="selectOperator(filter)">
                                @for (operator of filter.operators; track operator) {
                                    <mat-option
                                        [value]="operator"
                                        [attr.data-testid]="'data-list-filters-operator-option-' + operator">
                                        {{ "FILTER_OPERATORS." + operator | translate }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if (filter.values || filter.getValues) {
                            <mat-form-field class="cipo-input m-l-sm filter-field">
                                <mat-select
                                    formControlName="value"
                                    [multiple]="filter.multipleSelection"
                                    data-testid="data-list-filters-value-select"
                                    (opened)="loadValues(filter)"
                                    placeholder="Value">
                                    <!--
                  This makes sure that the overlay is opened on the right position (as if it would have filled with options)
                  this should be implemented in cipo-select after adding cipo-fields on filters -->
                                    @if (!filter.values?.length) {
                                        @for (item of [1, 2, 3, 4, 5, 6]; track $index) {
                                            <mat-option disabled>
                                                <ngx-skeleton-loader
                                                    [theme]="{
                                                        width: '100px',
                                                        height: '12px',
                                                        margin: '20px',
                                                    }"></ngx-skeleton-loader>
                                            </mat-option>
                                        }
                                    } @else {
                                        @for (value of filter.values; track value.key) {
                                            <mat-option
                                                [value]="value.key"
                                                [attr.data-testid]="'data-list-filters-value-option-' + value.key">
                                                {{ value.value | translate }}
                                            </mat-option>
                                        }
                                    }
                                </mat-select>
                            </mat-form-field>
                        } @else if (["text", "number"].includes(filter.type)) {
                            <mat-form-field
                                class="cipo-input m-l-sm filter-field"
                                data-testid="data-list-filters-value-input">
                                <input matInput placeholder="Value" formControlName="value" />
                            </mat-form-field>
                        } @else if (RANGE_FILTER_KEYS.includes(filterFormValue.operator)) {
                            <mat-form-field
                                class="cipo-input m-l-sm filter-field"
                                data-testid="data-list-filters-value-input">
                                <input
                                    matInput
                                    readonly
                                    [owlDateTime]="datePicker"
                                    selectMode="range"
                                    formControlName="value" />
                                <button
                                    mat-icon-button
                                    [owlDateTimeTrigger]="datePicker"
                                    matSuffix
                                    [attr.aria-label]="'a11y.form.openCalendar' | translate">
                                    <mat-icon aria-hidden="true">calendar_month</mat-icon>
                                </button>
                                <owl-date-time #datePicker pickerType="calendar"></owl-date-time>
                            </mat-form-field>
                        } @else {
                            <mat-form-field
                                class="cipo-input m-l-sm filter-field"
                                data-testid="data-list-filters-value-input">
                                <input matInput readonly [owlDateTime]="datePicker" formControlName="value" />
                                <button
                                    mat-icon-button
                                    [owlDateTimeTrigger]="datePicker"
                                    matSuffix
                                    [attr.aria-label]="'a11y.form.openCalendar' | translate">
                                    <mat-icon aria-hidden="true">calendar_month</mat-icon>
                                </button>
                                <owl-date-time #datePicker pickerType="calendar"></owl-date-time>
                            </mat-form-field>
                        }
                    </mat-expansion-panel>
                }
            }
        </mat-accordion>
    </div>
    <div fxLayoutGap="16px">
        <button mat-raised-button data-testid="data-list-filters-action-reset" (click)="resetFilter()" fxFlex>
            {{ "dataListCommand.clear" | translate }}
        </button>
        <button
            mat-raised-button
            data-testid="data-list-filters-action-close"
            color="accent"
            (click)="closeFilter()"
            fxFlex>
            {{ "general.close" | translate }}
        </button>
        <button
            mat-raised-button
            data-testid="data-list-filters-action-apply"
            color="primary"
            (click)="applyFilters()"
            fxFlex>
            {{ "dataListCommand.apply" | translate }}
        </button>
    </div>
</form>
